import React from 'react';
import {Input} from "antd";
import {IPropsElement} from "../../../pages/ChecklistPage/PopupEdit/constants";
import {callEventChecklist, getChecklist, useChecklist} from "../ChecklistContext";
import {patternFloat2} from "../../../util/varibles/constants";

const NumberElement: React.FC<IPropsElement> = (props) => {
    const {placeHolder} = props.properties;
    const {index} = props;
    const [value] = useChecklist(state => state.result[index]);
    const {onResultChange} = callEventChecklist();
    const {disabled} = getChecklist()();

    return <Input
        disabled={disabled}
        placeholder={placeHolder}
        value={value}
        onChange={({target}) => {
            const reg = new RegExp(patternFloat2);
            const value = target.value.trim();
            if (value.length === 0 || reg.test(value))
                onResultChange({[index]: value})
        }}
    />
};

export default NumberElement;
